<template>
  <div style="margin: 10px">
    <v-card>
      <v-card-text>
        <table class="lstTable">
          <tr>
            <th>Nhóm vật tư</th>
            <th>Mã vật tư</th>
            <th>Tên vật tư</th>
            <th>Đơn vị</th>
            <th>Số lượng</th>
            <th>Thành tiền</th>
          </tr>
          <tr style="font-weight: bold">
            <td colspan="4">Tổng tiền</td>
            <td style="text-align: right">
<!--              {{totalQuantity| currency}}-->
            </td>
            <td style="text-align: right">{{ totalAmount| currency}}
            </td>
          </tr>
          <template v-for="(value,name) in lstData" v-if="value != undefined">
            <tr v-for="(item,index) in value.items">
              <td :rowspan="value.row" v-if="index==0">{{ value.categoryName }}</td>
              <td>{{ item.materialCode }}</td>
              <td>{{ item.materialName }}</td>
              <td>{{ item.unit }}</td>
              <td style="text-align: right">{{ item.quantity | currency }}</td>
              <td style="text-align: right">{{ item.amount | currency }}</td>
            </tr>
          </template>
        </table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import {message} from "../../shared/message";
import moment from "moment";

export default {
  name: "material-report-summary",
  components: {},
  props: {
    search: {
      type: Object,
      default: () => {
        return null;
      },
    },
    reportData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },

  watch: {
    search: {
      handler(value) {
        this.calculateData();
      },
      deep: true
    }
  },

  data: () => {
    return {
      lstExport: [],
      lstData: [],
      lstMaterialType: [],
      totalQuantity: 0,
      totalAmount: 0,
    }
  },

  created() {
    this.getMaterialType();
  },

  methods: {
    getMaterialType() {
      //let url = process.env.VUE_APP_API_URL + "/category/listByTypeAndCode?type=MATERIAL_TYPE&code=VTN";
      let url = process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE";

      axios.post(url).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialType = data;
            }
          }
      );
    },

    calculateData() {
      // console.log(" recalculate");
      // console.log(this.reportData);
      this.lstData = [];
      let mtData = {};
      for (let key in this.reportData) {
        let lstExport = this.reportData[key].data;
        // console.log(" lstExport");
        // console.log(lstExport);
        for (let typeId in lstExport) {
          for (let i = 0; i < lstExport[typeId].items.length; i++) {
            if (lstExport[typeId].items[i].materialId != undefined && lstExport[typeId].items[i].materialId != null) {
              if (mtData[lstExport[typeId].items[i].materialId] == undefined || mtData[lstExport[typeId].items[i].materialId] == null) {
                mtData[lstExport[typeId].items[i].materialId] = Object.assign({}, lstExport[typeId].items[i]);
                mtData[lstExport[typeId].items[i].materialId].quantity = parseFloat(lstExport[typeId].items[i].quantity);
              } else {
                mtData[lstExport[typeId].items[i].materialId].quantity += parseFloat(lstExport[typeId].items[i].quantity);
              }
            }
          }
        }
      }
      // console.log(mtData);

      for (let key in mtData) {
        let typeId = mtData[key].typeId;
        if (this.lstData[typeId] == undefined || this.lstData[typeId] == null) {
          this.lstData[typeId] = this.lstMaterialType.filter(item => {
            return item.categoryId == typeId;
          })[0];
          this.lstData[typeId].row = 1;
          this.lstData[typeId].items = [mtData[key]];
        } else {
          this.lstData[typeId].items.push(mtData[key]);
          this.lstData[typeId].row = this.lstData[typeId].items.length;
        }
      }
      this.totalAmount = 0;
      this.totalQuantity = 0;
      for(let key in this.lstData){
        let items = this.lstData[key].items;
        for(let keyItem in items){
          let item = items[keyItem];
          // console.log(item.amount);
          this.totalAmount+=this.nvl(item.amount);
          this.totalQuantity+=this.nvl(item.quantity);
        }
      }
      this.$forceUpdate();
      this.$emit("finishCalculate");

    },

  },

  destroyed() {
  },
};
</script>

<style>
.indicator {
  margin: 5px 5px 5px 0px;
  padding: 5px;
  display: inline-block;
  border: 1px solid gray;
  width: fit-content;
}

.G2 {
  background-color: gold;
}

.G3 {
  background-color: crimson;
}
</style>